import { createContext, useContext, useEffect } from 'react';
import { useAuthContext } from './AuthProvider';
import { useHousehold } from '@/features/auth';
import { setSentryHousehold } from '@/lib/sentry';

const HouseholdContext = createContext(null);

export function HouseholdProvider({ children }) {
  const { user } = useAuthContext();
  const household = useHousehold(user);

  useEffect(() => {
    if (household?.householdId) {
      setSentryHousehold({ id: household.householdId, name: household.householdName });
    } else {
      setSentryHousehold(null);
    }
  }, [household?.householdId, household?.householdName]);

  return <HouseholdContext.Provider value={household}>{children}</HouseholdContext.Provider>;
}

export function useHouseholdContext() {
  const ctx = useContext(HouseholdContext);
  if (!ctx) throw new Error('useHouseholdContext must be used within HouseholdProvider');
  return ctx;
}
